import axios from 'axios'
import { apiClient, type ApiClient } from '../http'
import { logger } from '@/utils/logger'
import { getEnvVar, stripTrailingSlashes } from '@/utils/environment'
import type {
  ISubmitFeedbackApiRequest,
  IFeedbackTicketApiResponseData,
} from './types'

function getFeedbackBaseUrl(): string {
  const baseUrl = getEnvVar('VITE_FEEDBACK_API_BASE_URL')
  if (!baseUrl) {
    throw new Error('VITE_FEEDBACK_API_BASE_URL is not configured')
  }
  return stripTrailingSlashes(baseUrl)
}

class FeedbackApi {
  static async submitFeedback(
    data: ISubmitFeedbackApiRequest,
    client: ApiClient = apiClient
  ): Promise<IFeedbackTicketApiResponseData> {
    const authHeaders = await client.getAuthHeaders()
    const baseUrl = getFeedbackBaseUrl()

    logger.debug(
      'Submitting feedback',
      { baseUrl, category: data.Category, subject: data.Subject },
      { component: 'FeedbackApi' }
    )

    const response = await axios.post<IFeedbackTicketApiResponseData>(
      `${baseUrl}/v2/feedback`,
      data,
      {
        headers: {
          ...authHeaders,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  }
}

export { FeedbackApi }
